'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _playlists = require('redux/modules/playlists');

var playlistsActions = _interopRequireWildcard(_playlists);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

var _Playlists = require('helpers/Playlists');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./PlaylistsToggleViewButton.scss');

var PlaylistsToggleViewButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    viewType: state.playlists.viewType
  };
}, (0, _extends3.default)({}, playlistsActions)), _dec(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(PlaylistsToggleViewButton, _Component);

  function PlaylistsToggleViewButton() {
    (0, _classCallCheck3.default)(this, PlaylistsToggleViewButton);
    return (0, _possibleConstructorReturn3.default)(this, (PlaylistsToggleViewButton.__proto__ || (0, _getPrototypeOf2.default)(PlaylistsToggleViewButton)).apply(this, arguments));
  }

  (0, _createClass3.default)(PlaylistsToggleViewButton, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          toggleView = _props.toggleView,
          viewType = _props.viewType,
          className = _props.className;
      var t = this.context.t;

      var toggleViewClass = (0, _bind2.default)(styles.viewToggle, {
        'icon-list': viewType === _Playlists.viewTypes.grid,
        'icon-grid': viewType === _Playlists.viewTypes.list
      }, className);

      return _react2.default.createElement('i', { onClick: toggleView, className: toggleViewClass, title: t('Toggle view') });
    }
  }]);
  return PlaylistsToggleViewButton;
}(_react.Component), _class2.propTypes = {
  className: _propTypes2.default.string,
  toggleView: _propTypes2.default.func,
  viewType: _propTypes2.default.string
}, _class2.contextTypes = {
  t: _propTypes2.default.func
}, _temp)) || _class);
exports.default = PlaylistsToggleViewButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Playlists/components/PlaylistsToggleViewButton/PlaylistsToggleViewButton.js
// module id = 2186
// module chunks = 1